import { createBrowserRouter } from 'react-router';

import { CareerPage } from '@/pages/career';
import { DerbyPage } from '@/pages/derby';
import { DrawsPage } from '@/pages/draws';
import { HomePage } from '@/pages/home';
import { MatchesPage } from '@/pages/matches';
import { NotFoundPage } from '@/pages/not-found';
import { ProfilePage } from '@/pages/profile';
import { RatingPage } from '@/pages/rating';
import { ROUTES } from '@/shared/config';
import { AppLayout } from '@/widgets/app-layout';
import { DerbyNudgeModal } from '@/widgets/derby-nudge-modal';
import { ResultModalDebug, ResultModalHost } from '@/widgets/result-modal';
import {
  SeasonFinalModalDebug,
  SeasonFinalModalHost,
} from '@/widgets/season-final-modal';
import { SubscribeModal } from '@/widgets/subscribe-modal';
import { WelcomeModal } from '@/widgets/welcome-modal';

import { AnalyticsTracker } from '../providers/AnalyticsTracker';
import { RequireAuth } from './RequireAuth';
import { StartParamRedirect } from './StartParamRedirect';
import { RouteError } from './RouteError';

/**
 * Один защищённый корень вместо гарда на каждом маршруте: гард смонтирован
 * один раз, вход не перезапускается при переходах между вкладками.
 */
export const router = createBrowserRouter([
  {
    element: (
      <RequireAuth>
        <AppLayout>
          <AnalyticsTracker />
          <StartParamRedirect />
          <SubscribeModal />
          <WelcomeModal />
          {/* Показ решает сервер (`shouldNudge` в состоянии Дерби),
              закрытие отмечает POST /derby/nudge/seen. Панель сама
              уступает очередь приветствию новичка и итогам периодов —
              порядок держит она, а не место в этом списке. */}
          <DerbyNudgeModal />
          {/* Настоящие итоги приоритетнее приглашения подписаться: они
              одноразовые, `markSeen` их сжигает. Просмотр всех девяти
              вариантов по `?result=<id>` остался, но только в dev —
              из прод-бандла ветка выпадает целиком.

              Два хоста итогов, а не один: слой widgets не может
              импортировать widgets, поэтому Финал сезона держит свою
              модалку сам. Условия у них взаимоисключающие по `kind`,
              двух панелей разом не бывает. */}
          <ResultModalHost />
          <SeasonFinalModalHost />
          {import.meta.env.DEV ? <ResultModalDebug /> : null}
          {import.meta.env.DEV ? <SeasonFinalModalDebug /> : null}
        </AppLayout>
      </RequireAuth>
    ),
    errorElement: <RouteError />,
    children: [
      { path: ROUTES.home, element: <HomePage /> },
      { path: ROUTES.matches, element: <MatchesPage /> },
      { path: ROUTES.derby, element: <DerbyPage /> },
      { path: ROUTES.career, element: <CareerPage /> },
      { path: ROUTES.draws, element: <DrawsPage /> },
      { path: ROUTES.rating, element: <RatingPage /> },
      { path: ROUTES.profile, element: <ProfilePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
